module.controller('reissueHeaderCtrl', ['$scope', '$http', 'baseURI',  function($scope, $http, baseURI){
  $scope.title = 'Reissue Card';
  $scope.info = 'Your reissued card(s) will be shipped to the following address:';

  var url = baseURI + 'cardholder/profile';

  function getProfile(){
    $http.get(url).then(function (resp){
      var data = resp.data;

      // Add json object to use in select/options
      $scope.address1 = data.Data.Address1;
      $scope.address2 = data.Data.Address2 || null;
      $scope.address3 = data.Data.City + ' ' + data.Data.StateCode + ' ' + data.Data.PostalCode;

    }).catch(function(error){
      console.log('err', error);
    });
  }

  getProfile();

}]);
